/**
 * OptimizedFlowsContext — which flows have a Flow Optimizer config, provided
 * once by a hosting tab (the Flow Tree, the Paths tab) so every row can decide
 * whether to offer the "Flow Optimiser" button — and open its drawer in place,
 * since each entry carries the config's owning campaign.
 * For Media Devoted | Created By James Alexandrov
 *
 * Provided rather than fetched per row: the map is derived from both providers'
 * full config lists, and building it once beats rebuilding it in each of the
 * page's rows.
 */

import { createContext } from "react";

import type { OptimizedFlowTarget } from "./useOptimizedFlows";

/** Keys are `optimizedFlowKey(platform, flowId)`; null = not loaded yet. */
export const OptimizedFlowsContext = createContext<Map<
  string,
  OptimizedFlowTarget
> | null>(null);
